import Button from "@src/components/Button"

export default function CartEmpty() {
  return (
    <div
      className="p-4 lg:pr-8 lg:max-w-3xl lg:ml-auto flex flex-col justify-center h-full"
      data-component="cart-empty"
    >
      <h2 className="font-browser font-bold mb-2 text-2xl">
        Your basket is empty
      </h2>
      <p className="font-browser mb-8">
        It doesn&#8217;t look like you&#8217;ve added anything to your basket
        just yet.
      </p>
      <div>
        <Button text="Shop Now" url="/shop" />
      </div>
    </div>
  )
}
